// extracted by mini-css-extract-plugin
module.exports = {"Set":"Tag_Set__ZD7YN","Item":"Tag_Item__o7tEH"};